import { render, staticRenderFns } from "./DBInfo.vue?vue&type=template&id=414c19d5&scoped=true"
import script from "./DBInfo.vue?vue&type=script&lang=ts"
export * from "./DBInfo.vue?vue&type=script&lang=ts"
import style0 from "./DBInfo.vue?vue&type=style&index=0&id=414c19d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "414c19d5",
  null
  
)

export default component.exports